import {BaseMuixFilterController} from "../../../../components/muix-data-grid/controllers/BaseMuixFilterController.ts";
import {BagStore} from "../../../../stores/BagStore.tsx";
import {action, computed, makeObservable, observable} from "mobx";
import {SCPageController} from "./SCPageController.ts";
import {GridFilterItem} from "@mui/x-data-grid-premium";

export class SCFilterController extends BaseMuixFilterController {
    selectedSupplierSpend?: number;

    constructor(
        private controller: SCPageController,
        private bagStore: BagStore,
    ) {
        super(controller.tableController);
        makeObservable(this, {
            selectedSupplierSpend: observable,
            selectedCategoryLabel: computed,
            selectedCategoryKey: computed,
            canSelectLevelDeeper: computed,
            hasRemainingSelectionLevels: computed,
            supplierSearchValue: computed,
            setSelectedSupplierSpend: action,
            selectNextCategoryDown: action,
            selectCategorySibling: action,
            navigateToLevel: action,
            setSupplierSearch: action,
        });
    }

    get selectedCategoryLabel(): string | undefined {
        if (this.selectedCategory.length > 0) {
            return this.selectedCategory[this.selectedCategory.length - 1]
        }
        return undefined;
    }

    get selectedCategoryKey(): string | undefined {
        if (this.selectedCategory.length > 0) {
            return this.selectedCategory.join('|')
        }
        return undefined;
    }

    get canSelectLevelDeeper(): boolean {
        return this.bagStore.taxonomy_size > this.selectedLevel;
    }

    get hasRemainingSelectionLevels(): boolean {
        if (this.selectedLevel >= this.bagStore.taxonomy_size) {
            return false
        }
        // noinspection RedundantIfStatementJS
        if (this.selectedLevel >= 1 && !this.selectedCategoryLabel) {
            // Do not allow to go deeper in uncategorized
            return false;
        }
        return true;
    }

    get supplierSearchValue(): string {
        return this._muiXGridFilterModel.items.find(i => i.field === 's_name')?.value ?? '';
    }

    setSelectedSupplierSpend(value?: number) {
        this.selectedSupplierSpend = value;
    }

    selectNextCategoryDown(selectedCategory: string) {
        this.setSelectedCategory([...this.selectedCategory, selectedCategory])
    }

    selectCategorySibling(selectedCategory: string) {
        this.setSelectedCategory([...this.selectedCategory.slice(0, -1), selectedCategory])
    }

    navigateToLevel(level: number) {
        this.setSelectedCategory(this.selectedCategory.slice(0, level));
    }

    setSupplierSearch(search: string) {
        this._muiXGridFilterModel.items = [...this._muiXGridFilterModel.items.filter(
            i => i.field !== 's_name'
        )].concat(search === '' ? [] : [{
            id: 'supplier_id',
            field: 's_name',
            value: search,
            operator: 'contains'
        } as GridFilterItem]);
    }
}